import API_URL from '../../api/APIUrl'
import ReligionRow from './ReligionRow';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useReligionContext } from './useReligionContext';
import SideMenu from '../SideMenu';
import AddReligion from './AddReligion';

const ManageReligion = () => {

    const {religions, dispatch} = useReligionContext();

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPending, setIsPending] = useState(true);
    const [error, setError] = useState(null);

   useEffect(()=>{

    const fetchReligions = async () => {
        const response = await fetch(API_URL.GET_ALL_RELIGION + "?p=" + currentIndex);
        const json = await response.json();

        if(response.ok){
          setIsPending(false);
          setError(null);
           dispatch({type:'SET_RELIGIONS',payload:json});
        }
        else{
          dispatch({type:'SET_RELIGIONS',payload:null});
          setIsPending(false);
          setError('No data found!');
        }
    }
      fetchReligions();
},[dispatch,currentIndex]);

   
    const handlePrevClick = () => {
        if (currentIndex > 0) {
          setCurrentIndex(currentIndex - 1);
        }
        else{
          alert("No further records");
        }
      };
      
      const handleNextClick = () => {
          if(religions){
            //console.log("Data Array: " + JSON.stringify(religions));
            setCurrentIndex(currentIndex + 1);
          }
          else{
             alert("No further records")
          }
      };

    return (
        <>
         <div className="d-flex">
        <SideMenu />


        <div id="page-content-wrapper" style={{ flex: 1, padding: '20px' }}>
        <div className="container-fluid">
          <Link to="/admin/religion/create" className="list-group-item list-group-item-action bg-light">Add Religion</Link>
        <h2>Manage Religion</h2>

        <div className="table-responsive">
        <table className="table table-striped table-hover">
            <thead>
                <tr key={1}>
                <th scope="col">#</th>
                <th scope="col">Title</th>
                <th scope="col">Delete</th>
                </tr>
            </thead>
            <tbody>
            {error && <tr><td colSpan={3}>{error}</td></tr>}
            {isPending && <tr><td colSpan={3}>Loading....</td></tr>}
            { religions && religions.map((religion,index) => (
            
               <ReligionRow
               key={religion._id}
               id={index + 1}
               title= {religion.title}
               />
                 ))
              }
           
            </tbody>
            </table>
            { (
                    <nav aria-label="Page navigation example">
                               
                    <ul className="pagination justify-content-center">
                        <li className="page-item"><button className="page-link" onClick={handlePrevClick}>Previous</button></li>
                        <li className="page-item"><button className="page-link" onClick={handleNextClick}>Next</button></li>
                    </ul>

                    </nav>)

            }
        </div>
       
            </div>
            </div>

        </div>
        </>
     
    )
}

export default ManageReligion;